import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface DefaultParameterInterLibraryLoan {
  id: number
  systemUserId: number
  defaultType: string
  serial: number
  configBranchCode: SystemCode
  materialFormatCode: SystemCode
  holdingBranchCode: SystemCode
  collectionType: SystemCode
  interlibraryLoanCode: SystemCode
  borrowingDate: string
  borrowingPeriod: number
  defaultFlag: boolean
  revision: number
}

export const defaultDefaultParameterInterLibraryLoan = (): DefaultParameterInterLibraryLoan => ({
  id: 0,
  systemUserId: 0,
  defaultType: '',
  serial: 0,
  configBranchCode: defaultSystemCode(),
  materialFormatCode: defaultSystemCode(),
  holdingBranchCode: defaultSystemCode(),
  collectionType: defaultSystemCode(),
  interlibraryLoanCode: defaultSystemCode(),
  borrowingDate: '',
  borrowingPeriod: 0,
  defaultFlag: false,
  revision: 0
})

export function DefaultParameterInterLibraryLoanFromJSON(
  json: any
): DefaultParameterInterLibraryLoan {
  return {
    id: exists(json, 'id') ? json.id : 0,
    systemUserId: exists(json, 'system_user_id') ? json.system_user_id : 0,
    defaultType: exists(json, 'default_type') ? json.default_type : '',
    serial: exists(json, 'serial') ? json.serial : 0,
    configBranchCode: exists(json, 'config_branch_code')
      ? SystemCodeFromJSON(json.config_branch_code)
      : defaultSystemCode(),
    materialFormatCode: exists(json, 'material_format_code')
      ? SystemCodeFromJSON(json.material_format_code)
      : defaultSystemCode(),
    holdingBranchCode: exists(json, 'holding_branch_code')
      ? SystemCodeFromJSON(json.holding_branch_code)
      : defaultSystemCode(),
    collectionType: exists(json, 'collection_type')
      ? SystemCodeFromJSON(json.collection_type)
      : defaultSystemCode(),
    interlibraryLoanCode: exists(json, 'interlibrary_loan_code')
      ? SystemCodeFromJSON(json.interlibrary_loan_code)
      : defaultSystemCode(),
    borrowingDate: exists(json, 'borrowing_date')
      ? dateToPlainFormat(json.borrowing_date)
      : '',
    borrowingPeriod: exists(json, 'borrowing_period')
      ? json.borrowing_period
      : 0,
    defaultFlag: exists(json, 'default_flag') ? json.default_flag : false,
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
